import { ALBUMS } from "../content/gallery";
import { t } from "../i18n/dict";
import { langFromPath, localePath } from "../i18n/lang";
import { Page } from "../layout/Page";
import { Card } from "../ui/Card";
import { Reveal } from "../ui/Reveal";
import { Section } from "../ui/Section";

/**
 * The old site's `/galary` (and `/galary-HI`): the three photo albums as
 * cover cards, verbatim titles from the old album-picker carousel.
 */
export function GalleryPage() {
  const { lang } = langFromPath(window.location.pathname);

  return (
    <Page title="Gallery" heading="Gallery">
      <Section>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {Object.values(ALBUMS).map((album) => (
            <Reveal key={album.slug}>
              <Card
                title={album.title}
                image={album.cover}
                cta={{
                  label: t(lang, "viewAlbum"),
                  href: localePath(`/gallery/${album.slug}`, lang),
                }}
              >
                <p>
                  {`${album.photos.length} photographs`}
                  {album.videos.length > 0
                    ? ` · ${album.videos.length} videos`
                    : ""}
                </p>
              </Card>
            </Reveal>
          ))}
        </div>
      </Section>
    </Page>
  );
}
